import * as React from "react";
import { useDataLoader } from "react-remote-data-hooks";
import api from "../../api";
import API_DOMAIN from "../../api/apiDomain";
import noImage from "../../assets/images/user-noimage.png";
import { MediaFile } from "../../core";

interface IAvatarImage {
  id?: string;
  className?: string;
  alt?: string;
  title?: string;
  defaultImage?: string;
  width?: number;
  imageUrl?: string;
  image?: MediaFile;
}

export const CompanyAvatar: React.FunctionComponent<IAvatarImage> = (props) => {
  const imgRef = React.useRef<HTMLImageElement>(null);

  const addDefaultSrc = () => {
    if (imgRef && imgRef.current && imgRef.current.src) {
      imgRef.current.src = props.defaultImage || noImage;
    }
  };

  const { data: signedUrl, reload, loaded } = useDataLoader<string>(
    async (mediaFile?: MediaFile) =>
      mediaFile ? api.upload.getSignedMediaFileUrl(mediaFile) : undefined,
    [props.image]
  );

  return (
    <img
      src={signedUrl || `${API_DOMAIN}/api/company/${props.id}/logo`}
      className={props.className}
      alt={props.alt}
      title={props.title}
      width={props.width}
      ref={imgRef}
      onError={addDefaultSrc}
    />
  );
};
